import { userPermissions } from "@redotech/account-common/permissions";
import {
  getMockResponse,
  setMockResponse,
} from "@redotech/rpc-mock/mock-storage";

export function registerMerchantMockRpcResponses(): void {
  if (getMockResponse("checkActiveEscalation") === undefined) {
    setMockResponse("checkActiveEscalation", { activeEscalation: null });
  }
  if (getMockResponse("getUserPermissions") === undefined) {
    setMockResponse("getUserPermissions", {
      permissions: [...userPermissions],
    });
  }
}
